module.exports = __webpack_public_path__ + "static/images/dataImport/history_active.svg";